import React, { useCallback, useContext, FC } from 'react';
import Button from '@atlaskit/button';
import DropdownMenu, { DropdownItemRadio, DropdownItemRadioGroup } from '@atlaskit/dropdown-menu';
import PreferencesIcon from '@atlaskit/icon/glyph/preferences';

import {
  SLOCardViewType,
  SearchViewType,
  SearchConfigContext,
} from '@/controllers/search-config-controller';

import { settingsButtonStyles } from './styles';

type SearchSettingsDropdownProps = {
  isSearchViewTypeDisabled?: boolean;
  isSLOCardViewTypeDisabled?: boolean;
  isDisabled?: boolean;
};

const SearchSettingsDropdown: FC<SearchSettingsDropdownProps> = ({
  isDisabled,
  isSearchViewTypeDisabled,
  isSLOCardViewTypeDisabled,
}) => {
  const { searchViewType, sloCardViewType, setSearchViewType, setSLOCardViewType } = useContext(
    SearchConfigContext
  );

  const handleViewOptionSelect = useCallback(
    (type: SearchViewType) => {
      setSearchViewType(type);
    },
    [setSearchViewType]
  );

  const handleSLOCardViewOptionSelect = useCallback(
    (type: SLOCardViewType) => {
      setSLOCardViewType(type);
    },
    [setSLOCardViewType]
  );

  return (
    <DropdownMenu
      trigger={({ triggerRef, ...providedProps }) => (
        <span css={settingsButtonStyles}>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <Button isDisabled={isDisabled} ref={triggerRef} {...providedProps}>
            <PreferencesIcon label="Toggle preferences dropdown" />
          </Button>
        </span>
      )}
    >
      {!isSearchViewTypeDisabled && (
        <DropdownItemRadioGroup title="view option" id="view-option">
          <DropdownItemRadio
            isSelected={searchViewType !== SearchViewType.ComfortView}
            onClick={() => {
              handleViewOptionSelect(SearchViewType.LiteView);
            }}
            id="view-option-lite-view"
          >
            Lite view
          </DropdownItemRadio>
          <DropdownItemRadio
            isSelected={searchViewType === SearchViewType.ComfortView}
            onClick={() => {
              handleViewOptionSelect(SearchViewType.ComfortView);
            }}
            id="view-option-comfort-view"
          >
            Comfort view
          </DropdownItemRadio>
        </DropdownItemRadioGroup>
      )}
      {!isSLOCardViewTypeDisabled && (
        <DropdownItemRadioGroup title="slo card view option" id="slo-card-view-option">
          <DropdownItemRadio
            isSelected={sloCardViewType !== SLOCardViewType.ListView}
            onClick={() => {
              handleSLOCardViewOptionSelect(SLOCardViewType.GridView);
            }}
            id="slo-card-view-option-grid-view"
          >
            Grid view
          </DropdownItemRadio>
          <DropdownItemRadio
            isSelected={sloCardViewType === SLOCardViewType.ListView}
            onClick={() => {
              handleSLOCardViewOptionSelect(SLOCardViewType.ListView);
            }}
            id="slo-card-view-option-list-view"
          >
            List view
          </DropdownItemRadio>
        </DropdownItemRadioGroup>
      )}
    </DropdownMenu>
  );
};

export default SearchSettingsDropdown;
